import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import {isInt} from '../../../../atUtils'

export default class UsersCountInput extends TemplateView {
    constructor({
        setUsersCountAndUnlimitedFlag = () => {}
    }) {
        super()

        this.state = {
            maxUsersToUnlimited: 0,
            currentUsersCountSelected: 0,
            isSelectUnlimitedUsers: false,
            usersLowerLimit: 1,
        }

        this.actions = {
            setUsersCountAndUnlimitedFlag
        }

        this.onAnyStatePropertyChanged(['maxUsersToUnlimited', 'currentUsersCountSelected', 'isSelectUnlimitedUsers'], () => {
            if (this.state.currentUsersCountSelected > this.state.maxUsersToUnlimited) {
                this.$usersCount.val(messageResource.getMessage('licenses.chooser.unlimited', [this.state.maxUsersToUnlimited]))
            } else {
                this._setInputValue(this.state.currentUsersCountSelected)
            }
            this._disableButtons()
        })
    }

    templateHtml() {
        return '<div class="usersCountInput container">' +
               '    <div class="decrementUsers">' +
               '        <span><%=minus%></span>' +
               '    </div>' +
               '    <div>' +
               '        <input class="usersCount" type="text" maxlength="6"/>' +
               '    </div>' +
               '    <div class="incrementUsers">' +
               '        <span><%=plus%></span>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            plus: 'common.plus',
            minus: 'common.minus',
        }
    }

    afterRender() {
        this.$usersCount = this.find('.usersCount')
        this.$usersCount.on('change', () => {
            let value = this.$usersCount.val()

            if (isInt(value) && parseInt(value) >= this.state.usersLowerLimit) {
                value = parseInt(value)

                if (value > this.state.maxUsersToUnlimited) {
                    if (this.state.maxUsersToUnlimited !== this.state.currentUsersCountSelected) {
                        this.actions.setUsersCountAndUnlimitedFlag(true, this.state.maxUsersToUnlimited)
                    } else {
                        this._setInputValue(this.state.maxUsersToUnlimited)
                    }
                } else {
                    this.actions.setUsersCountAndUnlimitedFlag(false, value)
                }
            } else {
                this._setInputValue(this.state.currentUsersCountSelected)
            }
        })

        this.$decrementUsers = this.find('.decrementUsers')
        this.$decrementUsers.click(() => this._decrementUsers())

        this.$incrementUsers = this.find('.incrementUsers')
        this.$incrementUsers.click(() => this._incrementUsers())

        this.renderInitialState()
    }

    _decrementUsers() {
        if (this.state.currentUsersCountSelected !== this.state.usersLowerLimit) {
            let newUsersCount = this.state.currentUsersCountSelected - 1

            this.actions.setUsersCountAndUnlimitedFlag(false, newUsersCount)
        }
    }

    _incrementUsers() {
        if (!this.state.isSelectUnlimitedUsers) {
            let newUsersCount = this.state.currentUsersCountSelected + 1
            this.actions.setUsersCountAndUnlimitedFlag(newUsersCount > this.state.maxUsersToUnlimited, newUsersCount)
        }
    }

    _setInputValue(currentUsersCountSelected) {
        if (this.state.isSelectUnlimitedUsers) {
            this.$usersCount.val(messageResource.getMessage('licenses.chooser.unlimited', [this.state.maxUsersToUnlimited]))
        } else {
            this.$usersCount.val(currentUsersCountSelected)
        }
    }

    _disableButtons() {
        this.$decrementUsers.toggleClass('disable', this.state.currentUsersCountSelected === this.state.usersLowerLimit)
        this.$incrementUsers.toggleClass('disable', this.state.isSelectUnlimitedUsers)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/UsersCountInput.js